<template>
  <!--  <a-modal-->
  <!--      :title="title"-->
  <!--      :width="1020"-->
  <!--      :visible="visible"-->
  <!--      :confirmLoading="loading"-->
  <!--      :maskClosable="false"-->
  <!--      :centered="true"-->
  <!--      :footer="null"-->
  <!--      :destroyOnClose="true"-->
  <!--      @cancel="handleCancel"-->
  <!--  >-->
  <a-card :bordered="false">
    <div class="card-title">{{ $route.meta.title }}</div>

    <div class="table-operator">
      <a-button v-action:add type="primary" icon="plus" @click="handleAdd">新增</a-button>
      <SearchForm ref="SearchForm" @handleSubmit="handleSeachSubmit"/>
    </div>
    <s-table
        ref="table"
        rowKey="customer_id"
        :loading="isLoading"
        :columns="columns"
        :data="loadData"
        :pageSize="15"
        :scroll="{y:450}"
    >
      <div slot="status" slot-scope="text, item">
        <a-tag color="green" v-if="text===0">启用</a-tag>
        <a-tag color="red" v-else>停用</a-tag>
      </div>
      <div class="actions" slot="action" slot-scope="text, item">
        <a v-action:edit @click="handleEdit(item)">编辑</a>
        <a v-action:delete @click="handleDelete(item)">删除</a>
      </div>
    </s-table>
    <SaveForm
        ref="SaveForm"
        :waybill_id="waybill_id"
        @handleSubmit="handleRefresh(false)"
    />
  </a-card>
</template>

<script>
import * as Api from '@/api/data/customer'
import {STable} from '@/components'
import SaveForm from './modules/SaveForm'
import SearchForm from './modules/SearchForm'

export default {
  name: 'Index',
  components: {
    STable,
    SaveForm,
    SearchForm,
  },
  data() {
    return {
      // 标题
      title: '',
      // modal(对话框)是否可见
      visible: false,
      loading: false,
      // 查询参数
      queryParam: {
        waybill_id: ''
      },
      // 正在加载
      isLoading: false,
      // 表头
      columns: [
        // {
        //   title: '记录ID',
        //   dataIndex: 'customer_id'
        // },
        {
          title: '客户名称',
          dataIndex: 'customer_name',
        },
        {
          title: '启用状态',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'}
        },
        {
          title: '添加时间',
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: {customRender: 'action'}
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: param => {
        return Api.list({...param, ...this.queryParam})
            .then(response => {
              return response.data.list
            })
      },

      waybill_id: ''
    }
  },
  created() {

  },
  methods: {
    /**
     * 显示弹窗
     */
    open({waybill_id}) {
      this.waybill_id = waybill_id
      this.title = '客户列表'
      this.visible = true
    },
    /**
     * 新增记录
     */
    handleAdd() {
      this.$refs.SaveForm.add()
    },

    /**
     * 编辑记录
     */
    handleEdit(item) {
      this.$refs.SaveForm.edit(item)
    },

    handleCancel() {
      this.visible = false
    },

    /**
     * 删除记录
     */
    handleDelete(item) {
      const app = this
      const modal = this.$confirm({
        title: '您确定要删除该记录吗?',
        content: '删除后不可恢复',
        onOk() {
          return Api.deleted({customerId: item['customer_id']})
              .then((result) => {
                app.$message.success(result.message, 1.5)
                app.handleRefresh()
              })
              .finally(result => {
                modal.destroy()
              })
        }
      })
    },

    handleSeachSubmit(value) {
      this.queryParam = {
        ...this.queryParam,
        ...value
      }
      this.handleRefresh(true)
    },

    /**
     * 刷新列表
     * @param Boolean bool 强制刷新到第一页
     */
    handleRefresh(bool = false) {
      this.$refs.table.refresh(bool)
    },

    /**
     * 检索查询
     */
    onSearch() {
      this.handleRefresh(true)
    }

  }
}
</script>
